module.exports = __webpack_public_path__ + "static/img/sec1-cont03-img03.38b07d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec1-cont03-img03.jpg
// module id = r4JV
// module chunks = 0